var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#f8f9fd"}},[_c('el-header',[_c('top')],1),_c('el-container',{staticClass:"cont"},[_c('el-aside',{staticClass:"aside"},[_c('Sidebar')],1),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }